export default __webpack_public_path__ + "static/media/aboutps.f071c270.jpg";